import { z } from 'zod';
// Personal access tokens (user_api_keys) as returned to their owner (ADR-004).
// `key_hash` is NEVER part of any response shape by construction; the
// only credential fragment ever re-displayed is `key_hint` (the secret's last 4
// chars). The full secret (`emsp_…`) appears exactly once, in the create response.
//
// The row carries the raw lifecycle fields (expires_at / revoked_at / last_used_*);
// the frontend derives the display status (Active / Expired / Revoked) from them —
// no derived status on the wire (kept symmetric with the api_clients shape).
export const PersonalAccessTokenSchema = z
    .object({
    id: z.string().max(16),
    label: z.string().max(64),
    // The pinned project (id + display name resolved for the surface). Never null —
    // every PAT is pinned to exactly one project.
    project_id: z.string().max(16),
    project_name: z.string().nullable(), // null only if the project row vanished
    // The effective-at-mint read subset (already normalized: inert grants dropped).
    permissions: z.array(z.string()),
    key_hint: z.string().max(4).nullable(),
    last_used_at: z.string().datetime().nullable(),
    last_used_ip: z.string().nullable(),
    // null = never expires (the explicit "No expiry" choice).
    expires_at: z.string().datetime().nullable(),
    created_at: z.string().datetime(),
    revoked_at: z.string().datetime().nullable(),
})
    .strict();
export const PatsListResponseSchema = z
    .object({ items: z.array(PersonalAccessTokenSchema) })
    .strict();
// The show-once shape: `secret` is the full raw credential (`emsp_…`) — returned
// here and NEVER again (the DB holds only its SHA-256 + the last-4 hint).
export const CreatedPatResponseSchema = z
    .object({ pat: PersonalAccessTokenSchema, secret: z.string() })
    .strict();
